import React from 'react';

import { injectIntl } from 'react-intl';

import stripeImage from '../images/stripe.png';
import sslImage from '../images/sslgray.png';
import securityImage from '../images/seccondgray.png';
import privacyImage from '../images/privacygray.png';

function SecurityPaymentIcons(props) {
    return (
        <ul className="list-inline">
            <li style={{ marginRight: '5px' }}>
                <img
                    src={sslImage}
                    alt={props.intl.formatMessage({
                        id: 'secure-checkout',
                        defaultMessage: 'Secure Checkout',
                    })}
                    style={{ width: 'auto', height: '30px' }}
                />
            </li>
            <li style={{ marginRight: '5px' }}>
                <img
                    src={securityImage}
                    alt={props.intl.formatMessage({
                        id: 'secure-connection',
                        defaultMessage: 'Secure Connection',
                    })}
                    style={{ width: 'auto', height: '30px' }}
                />
            </li>
            <li style={{ marginRight: '5px' }}>
                <img
                    src={privacyImage}
                    alt={props.intl.formatMessage({
                        id: 'privacy-protected',
                        defaultMessage: 'Privacy Protected',
                    })}
                    style={{ width: 'auto', height: '30px' }}
                />
            </li>
        </ul>
    );
}

export default injectIntl(SecurityPaymentIcons);



/** WEBPACK FOOTER **
 ** ./src/components/security-icons.jsx
 **/